// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\na[data-v-c316a5c0] {\n  text-decoration: none;\n}\na > .card[data-v-c316a5c0]:hover {\n  background-color: rgba(144, 215, 236, 0.2);\n}\n.disabled[data-v-c316a5c0] {\n  -webkit-filter: grayscale(100%);\n          filter: grayscale(100%);\n  opacity: 70%;\n}\n.v-menu__content[data-v-c316a5c0] {\n  background-color: white;\n}\n", ""]);
// Exports
module.exports = exports;
